import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=889b7562&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=889b7562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889b7562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889b7562')) {
      api.createRecord('889b7562', component.options)
    } else {
      api.reload('889b7562', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=889b7562&scoped=true&", function () {
      api.rerender('889b7562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/views/Users.vue"
export default component.exports